import { GenericService } from '../GenericService'

class QuestionService extends GenericService {
    constructor() {
        super('/api/admin/question')
    }

    getSingleRecord = (id) => this.get('/api/question/getSingle/' + id)
    getCompanyQuestions = (data) =>
        this.post('/api/admin/question/getCompanyQuestions', data)
    markAsFirst = (data) => this.post('/api/admin/question/markAsFirst', data)
    multipleDelete = (data) =>
        this.post('/api/admin/question/multipleDelete', data)
}

export default new QuestionService()
